var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "ns-checkbox",
      class: { "nsc-enabled": _vm.enabled },
      style: {
        display: _vm.inline ? "inline-flex" : "",
        "line-height": _vm.size + "px"
      }
    },
    [
      _c(
        "span",
        {
          staticClass: "nsc-input",
          style: { width: _vm.size + "px", height: _vm.size + "px" }
        },
        [
          _c("input", {
            attrs: { type: "checkbox", disabled: !_vm.enabled },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event.target.checked)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "nsc-icon",
              style: {
                "background-color": _vm.value ? _vm.boxColor : "transparent",
                "border-color": _vm.boxColor
              }
            },
            [
              _c("NsIcon", {
                staticClass: "nsc-icon-check",
                attrs: { "icon-name": _vm.iconName, color: _vm.textColor }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.$slots.label ? _c("span", [_vm._t("label")], 2) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }